// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__2q97B","appLoading":"PageLoader_appLoading__33--X"};